export const taskConstants = {
    GETALL_REQUEST: 'TASKS_GETALL_REQUEST',
    GETALL_SUCCESS: 'TASKS_GETALL_SUCCESS',
    GETALL_FAILURE: 'TASKS_GETALL_FAILURE',

    CREATE_REQUEST: 'TASKS_CREATE_REQUEST',
    CREATE_SUCCESS: 'TASKS_CREATE_SUCCESS',
    CREATE_FAILURE: 'TASKS_CREATE_FAILURE', 

    DELETE_REQUEST: 'TASKS_DELETE_REQUEST',
    DELETE_SUCCESS: 'TASKS_DELETE_SUCCESS',
    DELETE_FAILURE: 'TASKS_DELETE_FAILURE',    

    STARTED_DRAGGING: 'TASK_STARTED_DRAGGING',
    STARTED_DROPPED: 'TASK_DROPPED',
};